import { Controller } from "@hotwired/stimulus"
import { showOverlay, hideOverlay } from "@/frontend/utils/modalHelpers"

export default class extends Controller {
  static values = {
    opened: { type: Boolean, default: false },
    context: { type: String, default: "top" },
  }

  connect() {
    this.boundClickOutside = (e) => this.clickOutside(e)

    this.open()
  }

  disconnect() {
    document.removeEventListener("click", this.boundClickOutside)
  }

  clickOutside(e) {
    // Hide a dropdown on a submit
    if (e.target.type === "submit") return (this.openedValue = false)

    // Don't pass click events to links outside this dropdown
    const isInsideModal = this.element.contains(e.target)
    if (!isInsideModal && this.contextValue === "bottom") e.preventDefault()
    if (isInsideModal) return

    this.openedValue = false
  }

  openedValueChanged() {
    document.removeEventListener("click", this.boundClickOutside)

    if (this.openedValue) {
      // Listen events only when a dropdown is opened
      document.addEventListener("click", this.boundClickOutside)

      this.element.classList.remove("hidden")
      if (this.contextValue === "bottom") showOverlay({ classes: ["z-20"] })
    } else {
      this.element.classList.add("hidden")
      hideOverlay({ classes: ["z-20"] })
    }
  }

  open() {
    this.openedValue = true
  }
}
